import { PICKUP_OPTIMYZER_STEP } from "../constants";

const CorrectPickupInfo = React.lazy(() => import("../CorrectPickupInfo"));
const SelectDrivers = React.lazy(() => import("../SelectDrivers"));
const OptimizationSolution = React.lazy(() =>
  import("../ReviewOptimizationSolution")
);
const Benefits = React.lazy(() => import("../Benefits"));

const OptimizationStepContent = ({ step, props }) => {
  const componentByStep = {
    [PICKUP_OPTIMYZER_STEP.CORRECT_PICKUP_INFO]: <CorrectPickupInfo {...props} />,
    [PICKUP_OPTIMYZER_STEP.SELECT_DRIVERS]: <SelectDrivers {...props} />,
    [PICKUP_OPTIMYZER_STEP.REVIEW_OPTIMIZED_SOLUTION]: <OptimizationSolution {...props} />,
    [PICKUP_OPTIMYZER_STEP.RESULTS]: <Benefits {...props} />,
  };
  return componentByStep[step] || <span>Unknown step</span>;
};

export default OptimizationStepContent;
